import trackEvent from "@/services/tracking";
export const productDetailsHelper = {
  data() {
    return {
      selectedVariant: null,
      hotListProducts: [],
      product: null,
      totalPrice: 0,
      totalQuantity: 0,
      activeImage: null,
      activeImageIndex: 0,
      quantity: null,
      selectedOption: {},
      faveData: null,
      showVideo: false,
      selectedVariants: [],
      multipleQuantityMode: false,
      hasInStockVariant: false,
    };
  },
  methods: {
    addToCart,
    onChangeSelection,
    isAddToCardEnabled,
    onAddMultipleVariantsToCart,
    onAddMultipleVariantsToCartAndContinue,
    addMultipleVariantsToCart,
    mapVariants,
    trackAddToCart,
    setActiveImage,
  },
};

function addToCart(keepAdding) {
  if (keepAdding) {
    this.onAddMultipleVariantsToCartAndContinue();
  } else {
    this.onAddMultipleVariantsToCart();
  }
  this.trackAddToCart();
}

function setActiveImage(variant) {
  const index = this.product?.images?.findIndex((image) => image.url === variant.image_url);
  this.activeImage = this.product?.images[index];
  this.activeImageIndex = index;
}

function onChangeSelection(selection) {
  this.selectedVariants = selection;

  if (this.selectedVariants?.length) {
    this.totalPrice = this.selectedVariants
      .map((item) => item.variant.price * item.quantity)
      .reduce((previousValue, currentValue) => previousValue + currentValue)
      .toFixed(2);

    this.totalQuantity = this.selectedVariants
      .map((item) => item.quantity)
      .reduce((previousValue, currentValue) => previousValue + currentValue);

    this.setActiveImage(this.selectedVariants[0].variant);
  } else {
    this.totalPrice = 0;
  }
}

function isAddToCardEnabled() {
  return this.selectedVariants.length && this.totalQuantity >= (this.product.wholesale_minimum || 1);
}

function onAddMultipleVariantsToCart() {
  this.addMultipleVariantsToCart();
}

function onAddMultipleVariantsToCartAndContinue() {
  this.addMultipleVariantsToCart(true);
}

function addMultipleVariantsToCart(keepAdding) {
  const { category, parentCategory } = this.$route.query;
  const obj = {
    product: this.product,
    variants: this.selectedVariants,
    entryPoint: "pdp",
    category_id: this.findProductCategoryIdByName(this.product, category, parentCategory),
    keepAdding,
  };

  this.$eventBus.$emit("add-multiple-variants", obj);
  this.$refs.variantPicker.clearSelection();
}

function mapVariants(variants) {
  return variants.map(
    ({
      pos_price,
      wholesale_price,
      id,
      characteristic_option,
      image_url,
      tester_minimum_quantity,
      tester_product_id,
      tester_variant_id,
      in_stock,
    }) => {
      return {
        id,
        pos_price,
        image_url,
        tester_minimum_quantity,
        tester_product_id,
        tester_variant_id,
        in_stock,
        price: wholesale_price,
        name: Object.values(characteristic_option).join(" "),
        option: characteristic_option,
      };
    }
  );
}

function trackAddToCart() {
  const { indexName, queryID, source } = this.$trackingStore.state,
    hasTrackingData = indexName !== null && queryID !== null && source !== null;
  if (hasTrackingData && source === "search") {
    trackEvent("PDP;Product Added to Cart after Search", {
      objectID: this.product.id,
      index: indexName,
      queryID: queryID,
    });
  } else if (hasTrackingData && source === "autocomplete") {
    trackEvent("AutoComplete;Product Added to Cart after Search", {
      objectID: this.product.id,
      index: indexName,
      queryID: queryID,
    });
  }
}
